module.exports = __webpack_public_path__ + "static/mr-press-25-997082c462d9f40b41701e1a4cac5509.jpg";